import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Stack } from '@mui/material';
import { LocationOn, Phone, Email, Facebook, Twitter, Instagram, LinkedIn } from '@mui/icons-material';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';

const socialLinks = [
  { icon: <Facebook color="primary" />, url: 'https://www.facebook.com/profile.php?id=100085588758846&mibextid=ZbWKwL' },
  { icon: <Twitter color="primary" />, url: 'https://x.com/MarwaHabib48820' },
  { icon: <Instagram color="primary" />, url: 'https://www.instagram.com/safahabibi111' },
  { icon: <LinkedIn color="primary" />, url: 'https://www.linkedin.com/in/marwa-habibi-2818b4372/' },
];

export default function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [contactSubmitted, setContactSubmitted] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    if (!e.target.checkValidity()) {
      e.target.reportValidity();
      return;
    }

    emailjs.sendForm(
      "service_xghqewb",
      "template_jt9rvfe",
      e.target,
      "wMK0pWL_GUXgiGsGS"
    )
    .then(() => {
      setContactSubmitted(true);
      e.target.reset();
      setFormData({ name: '', email: '', message: '' });
    })
    .catch((error) => {
      console.error("EmailJS error:", error);
      alert("Error sending message, please try again.");
    });
  };

  const handleChange = e => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 8, px: 3 }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Typography variant="h4" sx={{ fontWeight: '700', mb: 4, color: '#0d47a1' }}>
          Contact Us
        </Typography>

        {contactSubmitted ? (
          <Box
            sx={{
              mt: 4,
              p: 4,
              borderRadius: 3,
              backgroundColor: '#e3f2fd',
              color: '#0d47a1',
              fontWeight: '700',
              fontSize: '1.5rem',
              textAlign: 'center',
              boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
            }}
          >
            🎉 Thank you for reaching out! <br />
            We will get back to you shortly.
          </Box>
        ) : (
          <Box component="form" onSubmit={sendEmail} noValidate>
            <TextField
              fullWidth
              required
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              margin="normal"
              autoComplete="name"
            />
            <TextField
              fullWidth
              required
              label="Email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              margin="normal"
              autoComplete="email"
            />
            <TextField
              fullWidth
              required
              label="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              margin="normal"
              multiline
              rows={4}
            />
            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 3, backgroundColor: '#1976d2', '&:hover': { backgroundColor: '#115293' } }}
              fullWidth
            >
              Send Message
            </Button>
          </Box>
        )}

        {/* Contact Info */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: '700',
            mt: 6,
            mb: 3,
            color: '#0d47a1',
            borderBottom: '3px solid #1976d2',
            pb: 1,
            letterSpacing: 1,
            textTransform: 'uppercase',
          }}
        >
          Contact Info
        </Typography>
        <Stack spacing={3} mb={5}>
          <Box
            display="flex"
            alignItems="center"
            gap={1.5}
            sx={{
              bgcolor: '#e3f2fd',
              p: 2,
              borderRadius: 2,
              boxShadow: '0 2px 6px rgba(25, 118, 210, 0.2)',
              fontWeight: '500',
              fontSize: '1.1rem',
              color: '#0d47a1',
              transition: 'background-color 0.3s',
              '&:hover': { bgcolor: '#bbdefb' },
            }}
          >
            <LocationOn color="primary" sx={{ mr: 1 }} />
            Afghanistan, Mazar-e-Sharif, Hayat street
          </Box>
          <Box
            display="flex"
            alignItems="center"
            gap={1.5}
            sx={{
              bgcolor: '#e3f2fd',
              p: 2,
              borderRadius: 2,
              boxShadow: '0 2px 6px rgba(25, 118, 210, 0.2)',
              fontWeight: '500',
              fontSize: '1.1rem',
              color: '#0d47a1',
              transition: 'background-color 0.3s',
              '&:hover': { bgcolor: '#bbdefb' },
            }}
          >
            <Phone color="primary" sx={{ mr: 1 }} />
            @MarwaHabibi2025
          </Box>
          <Box
            display="flex"
            alignItems="center"
            gap={1.5}
            sx={{
              bgcolor: '#e3f2fd',
              p: 2,
              borderRadius: 2,
              boxShadow: '0 2px 6px rgba(25, 118, 210, 0.2)',
              fontWeight: '500',
              fontSize: '1.1rem',
              color: '#0d47a1',
              transition: 'background-color 0.3s',
              '&:hover': { bgcolor: '#bbdefb' },
            }}
          >
            <Email color="primary" sx={{ mr: 1 }} />
            marwahabibi789@gmail.com
          </Box>
        </Stack>

        {/* Follow Us */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: '700',
            mb: 2,
            color: '#0d47a1',
            borderBottom: '3px solid #1976d2',
            pb: 1,
            letterSpacing: 1,
            textTransform: 'uppercase',
          }}
        >
          Follow Us
        </Typography>
        <Stack direction="row" spacing={3} justifyContent="center" sx={{ mb: 6 }}>
          {socialLinks.map(({ icon, url }, i) => (
            <Box
              key={i}
              component="a"
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#1976d2',
                fontSize: '2rem',
                transition: 'color 0.3s',
                '&:hover': { color: '#0d47a1' },
              }}
            >
              {icon}
            </Box>
          ))}
        </Stack>
      </motion.div>
    </Box>
  );
}
